import { SUPPORTED_SOUNDCARDS } from '@/constants/supportedSoundcards'
import uniqBy from 'lodash/uniqBy'
import difference from 'lodash/difference'
import Vue from 'vue'

export default {
		namespaced: true,
		state: {
			videoSession: {
				id: '',
				videoUserId: '',
				videoSessionStart: null
			},
			opentok: {
				api_key: '',
				session_token: '',
				publisher_token: '',
				session: null,
				OTSession: null,
				publisher: null,
				subscriber: null,
				resolution: '1280x720',
				frameRate: 30,
				video: 1,
				audio: 1,
				error: {
					title: null,
					msg: null
				}
			},
			patient: null,
			appointment: null,
			smallToken: null,
			testPassed: false,
			useStethoscope: false,
			useLamp: false,
			muted: false,
			camShared: true,
			screenShared: false,
			source: null,
			audioSource: null,
			videoDevices: [],
			audioDevices: [],
			useFrontCamera: true,
			useRearCamera: false,
			menu: {
				activeNavItem: null,
				selectedVideoSource: null,
				selectedAudioSource: null
			},
			alert: {
				visible: false,
				text: null,
				variant: 'success'
			},
			session: null,
			error: {
				type: 0
			},
			db: null,
			documentsTable: {
				files: [],
				loading: false,
				uploader: {
					file: null,
					fileTypes: [],
					selectedType: 0
				}
			},
			lightbox: {
        items: [],
        index: null
      }
		},
		mutations: {
			setVideoSession (state, payload) {
				state.videoSession.id = payload.idVideoSession
				state.videoSession.videoUserId = payload.idVideoUser
				state.videoSession.videoSessionStart = payload.videoSessionStart
			},
			setError (state, payload) {
				state.error.type = payload
			},
			setResultVideoTest (state, payload) {
				state.videoTestPassed = payload
			},
			setSmallToken (state, payload) {
				state.smallToken = payload
			},
			setPatient (state, payload) {
				state.patient = payload
			},
			setAppointment (state, appointment) {
				state.appointment = appointment
			},
			setPublisher (state, publisher) {
				state.opentok.publisher = publisher
			},
			toggleAudio (state) {
				state.opentok.audio = !state.opentok.audio
			},
			setAudioOn (state) {
				state.opentok.audio = 1
			},
			setSessionOpentokToken (state, payload) {
				state.opentok.api_key = payload.opentokKey
				state.opentok.session_token = payload.opentokSession
				state.opentok.publisher_token = payload.opentokPublishToken
			},
			setVideoQuality (state, payload) {
				switch (payload) {
					case 1:
						state.opentok.resolution = '1280x720'
						state.opentok.frameRate = 30
						break
					case 2:
						state.opentok.resolution = '640x480'
						state.opentok.frameRate = 15
						break
					case 3:
						state.opentok.resolution = '320x240'
						state.opentok.frameRate = 1
						break
					default:
						state.opentok.resolution = '1280x720'
						state.opentok.frameRate = 30
						break
				}
			},
			disableVideo: function (state) {
				state.opentok.publisher.publishVideo(false)
			},
			setDb: function (state, db) {
				state.db = db
			},
			toggleStethoscope (state) {
				state.useStethoscope = !state.useStethoscope
			},
			toggleLamp (state, val) {
				state.useLamp = !state.useLamp
			},
			toggleVideoMute (state) {
				state.muted = !state.muted
			},
			toggleCameraShare (state) {
				state.camShared = !state.camShared
			},
			toggleShareScreen (state) {
				state.screenShared = !state.screenShared
			},
	/*     setApiToken (state, apiToken) {
				state.apiToken = apiToken
			}, */
			setDevices (state, devices) {
				const videoDevices = devices.filter(d => d.kind === 'videoinput')
				let audioDevices = [...devices.filter(d => d.kind === 'audioinput')]
				audioDevices = uniqBy(audioDevices, 'groupId')

				// Check if connected device is supported one
				if (audioDevices.length > state.audioDevices.length) {
					const newDevice = difference(audioDevices, state.audioDevices)
					if (newDevice.length > 0) {
						state.menu.selectedAudioSource = newDevice[0].deviceId
					}
				} else {
					state.menu.selectedAudioSource = audioDevices[0].deviceId
				}

				state.videoDevices = videoDevices
				state.audioDevices = audioDevices
				state.audioSource = audioDevices[0]
				/* state.menu.selectedAudioSource = audioDevices[0].deviceId */
				/* state.video.source = videoDevices[0] */
			},
			setAudioSource (state, source) {
				// Source is mediaStreamTrack
				state.audioSource = source
				/* state.menu.selectedAudioSource = source.deviceId */
				if (SUPPORTED_SOUNDCARDS.some(ss => source.label.includes(ss))) {
					state.useStethoscope = true
				} else if (!SUPPORTED_SOUNDCARDS.some(ss => source.label.includes(ss)) && state.useStethoscope) {
					state.useStethoscope = false
				}
			},
			setVideoSource (state, source) {
				state.source = source
			},
			setOpentokError (state, obj) {
				state.opentok.error = obj
			},
			setOTSession (state, session) {
				state.opentok.OTSession = session
			},
			setSelectedVideoSource (state, videoDevice) {
				if (!videoDevice) {
					state.menu.selectedVideoSource = state.videoDevices[0].deviceId
					return
				}
				// videoDevice could be either mediastreamtrack or deviceId
				const videoSource = !videoDevice.track ? state.videoDevices.find((item) => item.deviceId === videoDevice) : state.videoDevices.find((item) => item.deviceId === videoDevice.deviceId || item.label === videoDevice.track.label)
				if (videoSource) {
					state.menu.selectedVideoSource = videoSource.deviceId
				}
			},
			setSelectedAudioSource (state, mediaStreamTrack) {
				const audioSource = state.audioDevices.find((item) => item.label === mediaStreamTrack.label || item.deviceId === mediaStreamTrack.id)
				if (audioSource) {
					state.menu.selectedAudioSource = audioSource.deviceId
					if (SUPPORTED_SOUNDCARDS.some(ss => mediaStreamTrack.label.includes(ss))) {
						state.useStethoscope = true
					} else if (!SUPPORTED_SOUNDCARDS.some(ss => mediaStreamTrack.label.includes(ss)) && state.useStethoscope) {
						state.useStethoscope = false
					}
				}
			},
			toggleMobileCamera (state) {
				state.useFrontCamera = !state.useFrontCamera
				// useRearCamera is changed by v-model in switch component
				/* state.video.useRearCamera = !state.video.useRearCamera */
			},
			showVideoSidebarAlert (state, payload) {
				state.alert.text = payload.message
				state.alert.variant = payload.type || 'success'
				state.alert.visible = true
			},
			setMenuActiveNavItem (state, data) {
				state.menu.activeNavItem = data
			},
			setDocumentsTableFiles (state, files) {
				state.documentsTable.files = files
			},
			setDocumentsTableLoading (state, loading) {
				state.documentsTable.loading = loading
			},
			setDocumentsTableUploaderFile (state, file) {
				state.documentsTable.uploader.file = file
			},
			setDocumentsTableUploaderFileTypes (state, fileTypes) {
				state.documentsTable.uploader.fileTypes = fileTypes
			},
			setDocumentsTableUploaderSelectedType (state, type) {
				state.documentsTable.uploader.selectedType = type
			},
			addToLightbox (state, src) {
				let item = {
					src: src,
					mediaType: 'iframe'
				}
				state.lightbox.items.push(item)
				state.lightbox.index = state.lightbox.items.length - 1
			},
			resetLightbox (state) {
				state.lightbox.items = []
				state.lightbox.index = null
			},
		},
		getters: {
			getSelectedAudioSource: state => state.audioDevices.find((item) => item.deviceId === state.menu.selectedAudioSource)
		},
		actions: { 
			sendSignalCommand ({ state }, { command, errorCallback }) {
				return state.opentok.OTSession.signal({
					type: 'command',
					data: command
				}, errorCallback || function (error) {
					if (error) {
						console.log(error)
					}
				})
			},
			sendSignalMessage ({ state, dispatch }, { msg, callback }) {
				return dispatch('sendSignalCommand', {
					command: `${state.patient.name}: ${msg}`,
					errorCallback: callback
				})
			},
			sendSignalFileMessage ({ dispatch }, fileId) {
				return dispatch('sendSignalCommand', { 
					command: `newDocument;${fileId}`, 
					errorCallback: function (error) {
						if (error) {
							console.log('Error signalR file')
						} else {
							console.log(`${fileId} enviado`)
						}
					}
				})
			},
			loadDocumentsTable ({ commit, state }) {
				commit('setMenuActiveNavItem', 'docs')
				commit('setDocumentsTableLoading', true)
				Vue.prototype.$api.get(`AppointmentFiles/${state.appointment.id}`).then((response) => {
					commit('setDocumentsTableFiles', response.data.data)
					commit('setDocumentsTableLoading', false)
				})
			},
			uploadClinicalDocument: async function ({ state, commit }, { file, fileTagId }) {
				commit('setDocumentsTableLoading', true)
				if (file instanceof Array) {
					file = file[0]
				}
				const toBase64 = file => new Promise((resolve, reject) => {
					const reader = new FileReader()
					reader.readAsDataURL(file)
					reader.onload = () => {
						let encoded = reader.result.toString().replace(/^data:(.*,)?/, '')
						if ((encoded.length % 4) > 0) {
							encoded += '='.repeat(4 - (encoded.length % 4))
						}
						resolve(encoded)
					}
					reader.onerror = error => reject(error)
				})
				return Vue.prototype.$api.post('PatientsClinicalDocument', {
					id: state.patient.id,
					appointmentId: state.appointment.id,
					file: {
						base64: await toBase64(file),
						name: file.name,
						contentType: file.type,
						idFileTag: fileTagId
					}
				})
			},
			resetDocumentsTableUploader ({ commit }) {
				commit('setDocumentsTableUploaderFile', null)
				commit('setDocumentsTableUploaderSelectedType', 0)
			}
		}
}


// WEBPACK FOOTER //
// ./src/store/modules/video.js